<template>
    <authorization-layout
        :isLoading="isLoading"
        :statusCode="statusCode"
        :errorMessage="errorMessage"
        titlePage="Piattaforma di Ticketing"
        descriptionPage="Effettua il login alla piattaforma corretta. Ricorda che la Bitrix24 url deve esistere e ad essa è associato un solo indirizzo email. Per maggiori info contattare il servizio dedicato"
    >
        <template v-slot:form>
            <form>
                <p>Please login to your account</p>
                <div class="form-outline mb-4">
                    <input v-model="request.B24UrlInstance" type="url" id="form2Example11" class="form-control"
                    placeholder="https://example.com"  pattern="https://.*"/>
                    <label class="form-label" for="form2Example11">Bitrix24 url</label>
                    <vuelidate-error-container
                        :validationErrors="v$.B24UrlInstance.$errors"
                    ></vuelidate-error-container>
                </div>

                <div class="form-outline mb-4">
                    <input v-model="request.Email" type="email" id="form2Example11" class="form-control"
                    placeholder="User Name or email address" />
                    <label class="form-label" for="form2Example11">Username</label>
                    <vuelidate-error-container
                        :validationErrors="v$.Email.$errors"
                    ></vuelidate-error-container>
                </div>

                <div class="form-outline mb-4">
                    <input v-model="request.Password" type="password" id="form2Example22" class="form-control" 
                    placeholder="Password" />
                    <label class="form-label" for="form2Example22">Password</label>
                    <vuelidate-error-container
                        :validationErrors="v$.Password.$errors"
                    ></vuelidate-error-container>
                </div>
                <btn-login-container>
                    <template #buttons>
                        <button-login
                            :submit-btn-text="'Login'"
                            @onSubmitBtn="login"
                        >
                        </button-login>
                        <router-link class="text-muted" :to="{name: 'forgot_password'}">Reset Password</router-link>
                    </template>
                </btn-login-container>
            </form>
        </template>
    </authorization-layout>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import { ref, reactive, onMounted } from 'vue';
import {useVuelidate} from "@vuelidate/core";
import VuelidateErrorContainer from "@/components/containers/VuelidateErrorContainer.vue";
import { required, url, email } from "@vuelidate/validators";
import AuthorizationLayout from '@/layouts/AuthorizationLayout.vue';
import UseAuthenticationService from '@/services/composition/AuthenticationService';
import ButtonLogin from '@/components/form/ButtonLogin.vue';
import { useCookie } from "vue-cookie-next";
import BtnLoginContainer from '@/components/partials/BtnLoginContainer.vue';
const { getCookie, isCookieAvailable } = useCookie()
const router = useRouter();
const route = useRoute();
const isLoading = ref(false);
const be_url = ref(process.env.VUE_APP_BE_URL);
const request = reactive({
    Email: "",
    Password: "",
    B24UrlInstance: "",
});
const statusCode = ref(200);
const errors = ref([]);
const errorMessage = reactive({
    title: "",
    message: "",
})
const { CreateAxiosInstance } = UseAuthenticationService();

const rules = {
    Email: {
        required: required,
        email: email,
    },
    Password: {
        required: required
    },
    B24UrlInstance: {
        required: required,
        url: url,
    },
}

const v$ = useVuelidate(rules, request)

const login = async () => {
    const axios = CreateAxiosInstance();
    //var validation = await v$.value.$validate();
    const isFormCorrect = await v$.value.$validate()
    if(!isFormCorrect) return;
    isLoading.value = true;
    try
    {
        var res = await axios.post("/api/AppUsers/authentication/", request); 
        console.log(res);
        var token = res.data.token;
        if(route.query.returnUrl != null){
            router.push({path: "/user/validation", query: {placement: "EXTRANET", token: token, returnUrl: route.query.returnUrl}});
        }
        else{
            router.push({path: "/user/validation", query: {placement: "EXTRANET", token: token}});
        }
    }
    catch(err)
    {
        console.error(err);
        if(err.response.status == 307)
            return router.push({name:'change_password', query: {token: err.response.data.token, access_err: 307, userId: err.response.data.userId }})
        statusCode.value = err.response.status
        errorMessage.title = err.response.statusText
        errorMessage.message = err.response.data
    }
    finally
    {
        isLoading.value = false
    }
}

onMounted(()=>{
    request.Email = route.query.email;
    request.B24UrlInstance = route.query.url
})

</script>